import { TFunction } from 'i18next';

import Analytics from '../components/icons/analytics';
import Book from '../components/icons/book';
import File from '../components/icons/file';
import Finance from '../components/icons/finance';
import User from '../components/icons/user';
import Video from '../components/icons/video';
import { Paths, TMenuItem } from '../types/common';

export const appMainMenu: (t: TFunction<string[]>) => TMenuItem[] = (t) => [
  {
    path: Paths.VIDEO,
    activePathTrigger: [
      Paths.VIDEO,
      Paths.UPLOADED_VIDEO,
      Paths.VIDEO_CREATE,
    ],
    Icon: Video,
    text: t('menu.videos'),
  },
  {
    path: Paths.FILES,
    activePathTrigger: [Paths.FILES, Paths.UPLOADED_FILES],
    Icon: File,
    text: t('menu.files'),
  },
  {
    path: Paths.UPLOADED_VIDEOS_PLAYLIST,
    activePathTrigger: [Paths.UPLOADED_VIDEOS_PLAYLIST, Paths.PLAYLIST],
    Icon: Video,
    text: t('menu.playlist'),
  },
  {
    path: Paths.UPLOADED_PLAYCOURSES,
    activePathTrigger: [Paths.UPLOADED_PLAYCOURSES, Paths.PLAYCOURSE_ADMIN],
    Icon: Book,
    text: 'PlayCourse',
  },
  {
    path: Paths.VIEWED_PLAYLISTS,
    activePathTrigger: [Paths.VIEWED_VIDEOS, Paths.VIEWED_PLAYLISTS],
    Icon: Video,
    text: 'Education',
  },
  {
    path: Paths.ANALYTICS,
    activePathTrigger: [Paths.ANALYTICS],
    Icon: Analytics,
    text: t('menu.analytics'),
  },
  {
    path: `${Paths.FINANCE}?period=monthly&tab=plans`,
    activePathTrigger: [Paths.FINANCE],
    blockedModal: {
      content:
        'To enable this feature, please contact your service provider.',
      okText: 'OK',
      title: 'Feature unavailable',
    },
    Icon: Finance,
    text: t('menu.finance'),
  },
  {
    path: Paths.ACCOUNT,
    activePathTrigger: [Paths.ACCOUNT],
    Icon: User,
    text: t('menu.profile'),
  },
];

export const appAdminMenu: (t: TFunction<string[]>) => TMenuItem[] = (t) => [
  {
    path: Paths.USERS_ACCESS,
    activePathTrigger: [Paths.USERS_ACCESS],
    Icon: User,
    text: t('menu.users'),
  },
];

export const appStudentMenu: (t: TFunction<string[]>) => TMenuItem[] = (t) => [
  {
    path: Paths.PLAYLISTS,
    activePathTrigger: [Paths.PLAYLISTS],
    Icon: Video,
    text: 'Playlist',
  },
  {
    path: Paths.PLAYCOURSE,
    activePathTrigger: [Paths.PLAYCOURSE],
    Icon: Book,
    text: 'PlayCourse',
  },
  {
    path: Paths.ACCOUNT,
    activePathTrigger: [Paths.ACCOUNT],
    Icon: User,
    text: t('menu.profile'),
  },
];
